export default __webpack_public_path__ + "static/media/logo.c29e8e35.png";